<template>
    <el-aside :class="isCollapse?'left_side collapse':'left_side'">
        <div>
            <div class="logo_container">
            <img src="../../assets/images/logo/logo.png?v=20200513" alt="">
        </div>
        <div class="logo_container logo_thumb">
            <img src="../../assets/images/logo/logo_thumb.png?v=20200513" alt="">
        </div>
        <el-scrollbar>
            <el-menu background-color="#72246C" text-color="#ccc" active-text-color="#fff" unique-opened :collapse="isCollapse" :collapse-transition="false" :router="true" :default-active="navActiveIndex" :default-openeds="defaultOpeneds" class="menu_vertical">
                <!-- <el-menu-item index="/index"  @click="jumpToNav('/index')" v-show="userType===1 || userType===0">
                    <i class="el-icon-s-home"></i>
                        <span slot="title">首页</span>
                </el-menu-item> -->
                <el-menu-item index="/upload"  @click="jumpToNav('/upload')">
                   <i class="el-icon-upload"></i>
                        <span slot="title">上传视频</span>
                </el-menu-item>
                <el-menu-item index="/list"   @click="jumpToNav('/list')">
                    <i class="el-icon-s-order"></i>
                        <span slot="title">视频列表</span>
                </el-menu-item>
                <el-menu-item  index="/account"   @click="jumpToNav('/account')" v-show="userType===1 || userType===0">
                    <i class="el-icon-s-tools"></i>
                        <span  slot="title">账号管理</span>
                </el-menu-item> 
                <!-- <el-menu-item  index="/setting"   @click="jumpToNav('/setting')">
                    <i class="el-icon-s-tools"></i>
                        <span  slot="title">设置</span>
                </el-menu-item>  -->
            </el-menu>
        </el-scrollbar>
        </div>
    </el-aside> 
</template>

<script>
export default {
    data(){
        return {
            navActiveIndex:'',
            defaultOpeneds:[],
            defaultOpens:[],
            isCollapse: false,
        }
    },
    created(){
        this.setMenuActive();
    },
    mounted(){
        let that = this;
        this.$Bus.$on("collapseChange", () => {
            that.isCollapse = !that.isCollapse;
        });
    },
    methods:{
        setMenuActive(){
              this.navActiveIndex = '/'+this.getLastUrl() ? '/'+this.getLastUrl() : '/index';
        },
        jumpToNav(url){
            this.navActiveIndex = url; 
        }
    },
    props:['userType']
}
</script>